import React, {useState, useEffect, Fragment, useContext} from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
  Input,
  Table
} from 'reactstrap';
import Button from '../Button/Button';
import {useErrorToast} from '../../hooks/useErrorToast';
import sof from '../../stacks/sourceOfFunds/sourceOfFundsAWS';
import SourceOfFundsModificationScreen from '../SourceOfFundsModificationScreen/SourceOfFundsModificationScreen'
import {CurrentState} from '../../context';

const SourceOfFundsDetailScreen = props => {
  const [users,setUsers] = useState()
  const {setErrorMsg,errorToast} = useErrorToast('');
  const currentState = useContext(CurrentState);
  const {sub} = currentState

  const {sofUserId, setIsAdmin} = props
  // const sofAPI = sof.getInstance();

  useEffect(() => {
    async function listUsers() {
      try {
        const sofAPI = sof.getInstance();
        const data = await sofAPI.listSofUsers()
        setUsers(data)
      }
      catch(err) {
        // setIsAdmin(false)
        setErrorMsg(`listUsers error: ${err.code} ${err.message}`);
        console.error(`listUsers error: ${err.code} ${err.message}`);
      }
    }
    listUsers()
  },[sofUserId, setIsAdmin, setErrorMsg])

  async function addToAdmin(sofUserId) {
    try {
      const sofAPI = sof.getInstance();
      await sofAPI.addSofUserToAdmin(sofUserId)
    }
    catch(err) {
      setErrorMsg(`addToAdmin error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`addToAdmin error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  async function removeFromAdmin(sofId, sofUserId) {
    try {
      const sofAPI = sof.getInstance();
      await sofAPI.removeSofUserFromAdmin(sofUserId)
      // update({isAdmin: false})
      if (sub !== sofId) {
        window.location = '/'
      }
    }
    catch(err) {
      setErrorMsg(err.message);
      console.error(`removeFromAdmin error: ${JSON.stringify(err.message,null,2)}`);
      throw err
    }
  }

  async function adminCheck(userIndex, e) {
    if (users === undefined) return
    let newUsers = users.filter(() => true)
    let user = newUsers[userIndex]

    const checked = e.target.checked
    if (checked) {
      user.isAdmin = checked
    } else {
      delete user.isAdmin
    }
    setUsers(newUsers)

    if (checked) {
      await addToAdmin(user.sofUserId )
    } else {
      try {
        await removeFromAdmin(user.sofId, user.sofUserId )
      }
      catch (err) {
        newUsers[userIndex].isAdmin = true
        setUsers([...newUsers])
      }
    }
  }

  async function resendPassword(sofUserId) {
    try {
      const sofAPI = sof.getInstance();
      await sofAPI.resendPasswordToSofUser(sofUserId)
    }
    catch(err) {
      setErrorMsg(`resendPassword error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`resendPassword error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  async function resetPassword(sofUserId) {
    try {
      const sofAPI = sof.getInstance();
      await sofAPI.resetPasswordToSofUser(sofUserId)
    }
    catch(err) {
      setErrorMsg(`resetPassword error: ${JSON.stringify(err.message,null,2)}`);
      console.error(`resetPassword error: ${JSON.stringify(err.message,null,2)}`);
    }
  }

  const UsersList = () => {
    if (users === undefined) return []
    return users.map((item, index) => {
      return (
        <tr key={item.sofUserId}>
          <td>
            <UserLink onClick={(e) => {props.setSofUserId(item.sofUserId)}}>{item.user.userUserId}</UserLink>
          </td>
          <td>
            {`${item.user.userLastName}, ${item.user.userFirstName}`}
          </td>
          <td>
            {item.user.userEmail}
          </td>
          <td>
            <Input
              type='checkBox'
              checked={item.isAdmin}
              onChange={(e) => {
                adminCheck(index, e)
              }}
            />
          </td>
          <td>
            <Button click={() => resendPassword(item.sofUserId)} small>Resend</Button>
          </td>
          <td>
          <Button click={() => resetPassword(item.sofUserId)} small>Reset</Button>
          </td>
          {/* <td>
            {item.sofUserId}
          </td> */}
        </tr>
      )}
    )
  }

  const addUser = () => {
    props.setSofUserId('add')
  }

  return (
    <Fragment>
      <Container>
        <Row>
          <Col>
            <SourceOfFundsModificationScreen />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button small click={addUser}>ADD USER</Button>
          </Col>
        </Row>
        <Row>
          <Table>
            <thead>
              <tr>
              <th>UserId</th>
              <th>Name</th>
              <th>Email</th>
              <th>Admin</th>
              <th>ResendPW</th>
              <th>ResetPW</th>
              </tr>
            </thead>
            <tbody>
            <UsersList/>
            </tbody>
          </Table>
        </Row>
      </Container>
    {errorToast}
    </Fragment>
  );
};

const UserLink = styled.span`
  text-decoration: underline;
  :hover {
    background: lightGrey;
  };
  cursor: pointer
`

export default SourceOfFundsDetailScreen;
